module.exports = __webpack_public_path__ + "img/face-grin-wide.54bb1988.svg";